/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_Order_Pipeline_TitleInputs */

const en_logistics_order_pipeline_title = /** @type {(inputs: Logistics_Order_Pipeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Pipeline`)
};

const es_logistics_order_pipeline_title = /** @type {(inputs: Logistics_Order_Pipeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de pedidos`)
};

/**
* | output |
* | --- |
* | "Order Pipeline" |
*
* @param {Logistics_Order_Pipeline_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const logistics_order_pipeline_title = /** @type {((inputs?: Logistics_Order_Pipeline_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_Order_Pipeline_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_order_pipeline_title(inputs)
	return es_logistics_order_pipeline_title(inputs)
});